import { Component, OnInit, Output, Input} from '@angular/core';

@Component({
  selector: 'app-plan-info',
  templateUrl: './plan-info.component.html',
  styleUrls: ['./plan-info.component.sass']
})
export class PlanInfoComponent implements OnInit {
  @Input() plan_name;
  @Input() plan_price;
  @Input() plan_description;
  @Input() additional_serv;
  @Input() totalRateField;
  @Input() typeAccount;
  constructor() { }

  ngOnInit() {
  }

}
